// @ts-check
import { alerts } from './configs/alerts';
import { app } from './configs/app';
import { auctions } from './configs/auctions';
import { boxReadings } from './configs/boxReadings';
import { dumping } from './configs/dumping';
import { expeditions } from './configs/expeditions';
import { informationBar } from './configs/informationBar';
import { internalConfigurations } from './configs/internalConfigurations';
import { inventoryRegularization } from './configs/inventoryRegularization';
import { palletizing } from './configs/palletizing';
import { palletizingPoints } from './configs/palletizingPoints';
import { picking } from './configs/picking';
import { returnables } from './configs/returnables';
import { sideNavbar } from './configs/sideNavbar';
import { traceability } from './configs/traceability';

// [!] Here go all the settings. If the category is not included here, the settings
// from that category will not be loaded.
export const configsSettings = {
  alerts: alerts(),
  app: app(),
  auctions: auctions(),
  boxReadings: boxReadings(),
  dumping: dumping(),
  expeditions: expeditions(),
  informationBar: informationBar(),
  internalConfigurations: internalConfigurations(),
  inventoryRegularization: inventoryRegularization(),
  palletizing: palletizing(),
  palletizingPoints: palletizingPoints(),
  picking: picking(),
  returnables: returnables(),
  sideNavbar: sideNavbar(),
  traceability: traceability(),
};

/** @typedef {typeof configsSettings} ConfigsSettings */
/** @typedef {ConfigsSettings[keyof ConfigsSettings]['properties']} SettingsKeysUnion */
/** @typedef {import('./types').FlattenUnion<SettingsKeysUnion>} SettingsFlatten */
/** @typedef {keyof import('./types').FlattenUnion<SettingsKeysUnion>} SettingsKeys */
